export default "__VITE_ASSET__D_57byL8__"